<template>
  <div>
    <div class="org-header">
      <h3><strong>Summary</strong></h3>
      <div class="">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-body">
                <h1 class="mb-0 pb-0 fw-bold">{{ profile.title }}</h1>
                <p href="#">{{ profile.CreatedAt | moment("ll") }}</p>

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active text-dark"
                      data-bs-toggle="tab"
                      data-bs-target="#description"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Description
                    </button>
                  </li>
                  <!-- <li
                    class="nav-item"
                    role="presentation"
                    v-if="profile.checklist_url != ''"
                  >
                    <a
                      :href="profile.checklist_url"
                      target="_blank"
                      class="nav-link text-dark"
                      >Checklist</a
                    >
                  </li> -->
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link text-dark"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#update"
                      type="button"
                      role="tab"
                      aria-controls="contact"
                      @click="refresh = Math.random()"
                      v-if="isSuperAdmin || isPentester"
                    >
                      Edit test
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link text-dark"
                      data-bs-toggle="tab"
                      data-bs-target="#scope"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Scope & credentials
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active pt-4"
                    id="description"
                    role="tabpanel"
                  >
                    <div v-if="profile.scanner_status == 1">
                      <span class="text-danger">Scanner URL</span>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        :value="this.$server + 'organisation/'+ this.$route.params.org_id +'/projects/' + this.$route.params.prod_id + '/scansend?token=' + profile.scanner_token.trim() + '&amp;version=[yourVersion]'"
                      />
                    </div>
                    <div v-html="profile.description"></div>
                  </div>
                  <div class="tab-pane fade pt-4" id="scope" role="tabpanel">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#addAssets"
                      v-on:click="scope_id = 0"
                      class="btn btn-outline-info rounded-pill ps-3 pe-3 btn-sm float-end">
                      Add asset
                    </button>
                    <button class="d-none" data-bs-toggle="modal" data-bs-target="#addCredential" id="triggerCredential"></button>
                    <button class="d-none" data-bs-toggle="modal" data-bs-target="#addNotes" id="triggerModalsNote"></button>

                    <div class="">
                      <h3>In Scope</h3>
                      <div class="table-responsive">
                        <table class="table">
                          <tbody>
                            <tr v-for="s in scopes" :key="s.id">
                              <td width="10%">{{ s.type }}</td>
                              <td width="60%">
                                <strong>{{ s.identifier }}</strong>
                                <p class="text-muted">
                                  {{ s.description }}
                                </p>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn btn-text text-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addCredential"
                                  v-on:click="scope_id = s.id"
                                  >Credentials</button>

                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addAssets"
                                    v-on:click="scope_id = s.id; refresh = Math.random()"
                                    >
                                    <i class="far fa-edit"></i>
                                  </a>
                                  |
                                  <a
                                    href="javascript:void(0)"
                                    v-on:click="deleteScope(s.id)"
                                    >
                                    <i class="fa fa-trash text-danger"></i>
                                  </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade pt-4" id="update" role="tabpanel">
                    <h3>Update project</h3>
                    <Projects
                      v-on:callback="formCallback"
                      :project_id="profile.ID"
                      title="Update"
                      :key="refresh"
                    />
                  </div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-link text-danger mt-4"
              @click="deleteProject"
              v-if="isSuperAdmin || isPentester"
            >
              <i class="far fa-trash-alt"></i>
              Delete test
            </button>
          </div>
          <div class="col">
            <div class="card mb-2">
              <div class="card-body text-center graph-report">
                <h3 class="mb-4">Vulnerabilities</h3>
                <vue-ellipse-progress
                  color="#91d050"
                  :thickness="20"
                  emptyThickness="10%"
                  :progress="progress"
                >
                  <h1>
                    <span class="text-success">{{ profile.resolved }}</span>
                    <span class="text-muted">/</span>
                    <span class="text-danger" v-if="profile.resolved != profile.reports">{{ profile.reports }}</span>
                    <span class="text-success" v-else>{{ profile.reports }}</span>
                  </h1>
                </vue-ellipse-progress>
              </div>
            </div>

            <!-- <div class="card mt-4">
              <div class="card-body">
                <div class="">
                  <h3>Hacktivity</h3>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="addAssets"
      tabindex="-2"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3 v-if="scope_id == 0">Add Scope</h3>
            <h3 v-else>Update Scope</h3>
            <button
              type="button"
              id="closeScope"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <Scope v-on:callback="scopeCallback" :scope_id="scope_id" :key="refresh" />
          </div>
        </div>
      </div>
    </div>
    <!-- credential -->
    <div
      class="modal"
      id="addCredential"
      tabindex="-2"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Add Testing Credentials</h3>
          </div>
          <div class="modal-body">
            <Credential :scope_id="scope_id" :key="scope_id" v-if="scope_id != 0" />
            <div class="row">
              <div class="col-12 text-end">
                <button type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  class="btn text-white btn-info"
                  onclick="document.getElementById('triggerModalsNote').click()">Save & Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="addNotes"
      tabindex="-2"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Would you like to add notes?</h3>
            <button
              type="button"
              id="closeNote"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <textarea rows="5" class="form-control mb-2" v-model="scope_note"></textarea>
            <div class="row">
              <div class="col-12 text-end">
                <button type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  class="btn text-white btn-info" v-on:click="scopeComplete()">Complete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Projects from './projectForm.vue'
import { VueEllipseProgress } from "vue-ellipse-progress";
import Scope from '@/views/Project/scopeForm.vue'
import Credential from '@/views/Project/credentialForm.vue'

export default {
  components: {
    Projects,
    VueEllipseProgress,
    Scope,
    Credential
  },
  data () {
    return {
      messageWhenNoItems: 'There are not items',
      // timelineItems: [],
      progress: 0,
      profile: {
        ID: 0,
        url : '',
        description: '',
        CreatedAt: ''

      },
      scopes: null,
      scope_id: 0,
      scope_note: '',
      ScopeEdit: {
        id: '',
        identifier: '',
        type: ''

      },
      refresh: Math.random(),
      // reportTimeLine: [
      //   {
      //     from: new Date(2022, 2, 1),
      //     title: 'SQL Injection was found',
      //     showDayAndMonth: true,
      //     color: '#ff0001'
      //   },
      //   {
      //     from: new Date(2022, 2, 1),
      //     title: 'XSS was found',
      //     showDayAndMonth: true,
      //     color: '#ffc000'
      //   },
      //   {
      //     from: new Date(2022, 2, 2),
      //     title: 'SQL Injection was marked as <strong>resolved</strong>',
      //     showDayAndMonth: true,
      //     color: 'green'
      //   },
      // ]
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters({
      isSuperAdmin: 'auth/isSuperAdmin',
      isPentester: 'auth/isPentester'
    })
  },
  methods: {
    init() {
      this.refresh = Math.random();
      const me = this;
      this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id)
      .then(res => {
        var r = res.data;
        if (r.success) {
            me.profile = r.data[0];
            me.progress = r.data[0].resolved * 100 / r.data[0].reports;
            me.scopes = r.scopes;
            if (isNaN(me.progress)) {
              me.progress = 0;
            }
        }

      });
    },

    formCallback(res) {
      if (res) { // any random value return true
        this.init();
      }
    },

    scopeComplete() {
      const me = this;
      this.$axios.put(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + this.scope_id, {
            'description': this.scope_note
          }).then(res => {
            if (res.data.success) {
              this.$swal({
                title: 'Scope added successfully'
              });
              document.getElementById('closeNote').click();
              me.init();
          }
        });
    },

    scopeCallback(scope_id) {

      document.getElementById("closeScope").click(); // close modals
      if (scope_id == "updated") {
        this.scope_id = 0;
        this.init();
      } else {
        this.scope_id = scope_id;
        document.getElementById("triggerCredential").click(); // open credential modals

      }
    },

    deleteProject() {
      let comp = confirm("Are you sure you want to delete?");

      if (comp) {
        const me = this;
        this.$axios.delete(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id)
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.$swal({
                  title: r.message
              });
              me.$router.push({ path: "/" + me.$route.params.org_id + "/dashboard" });
          }
        });
      }
    },

    deleteScope(id) {
      let comp = confirm("Are you sure you want to delete?");

      if (comp) {
        const me = this;
        this.$axios.delete(me.$server + 'organisation/' + this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/scope/' + id)
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.$swal({
                  title: r.message
              });
              me.init();
          }
        });
      }
    }
  }
}
</script>